import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';
// import { Attrs } from './certification.attrs';

/**
 * 'certification': '资质管理',
 * name: 'Certification',
 */
const route: AppRouteModule = {
  path: '/certification',
  name: 'Certification',
  component: LAYOUT,
  redirect: '/certification/license',
  meta: {
    icon: 'mingcute:certificate-line',
    title: t('routes.certification.main'),
    orderNo: 1000,
    roles: [20220843],
  },
  children: [
    /**
     * 'license': '许可证营业执照上传',
     * name: 'CertificationLicense',
     */
    {
      path: 'license',
      name: 'CertificationLicense',
      component: () => import('/@/views/certification/license/index.vue'),
      meta: {
        title: t('routes.certification.license'),
        roles: [20220844],
      },
    },
    /**
     * 'inspection-report': '外检报告上传',
     * name: 'CertificationInspectionReport',
     */
    {
      path: 'inspection-report',
      name: 'CertificationInspectionReport',
      component: () => import('/@/views/certification/inspection-report/index.vue'),
      meta: {
        title: t('routes.certification.inspection-report'),
        roles: [20220867],
      },
    },
    /**
     * 'tax-payment-certification-declaration': '完税认证申报',
     * name: 'TaxPaymentCertificationDeclaration',
     */
    {
      path: 'tax-payment-certification-declaration',
      name: 'TaxPaymentCertificationDeclaration',
      component: () => import('/@/views/certification/tax-payment-certification-declaration/index.vue'),
      meta: {
        title: t('routes.certification.tax-payment-certification-declaration'),
        roles: [20222607],
      },
    },
    /**
     * 'tax-audit-list': '完税认证申报记录查询',
     * name: 'TaxAuditList',
     */
    {
      path: 'tax-audit-list',
      name: 'TaxAuditList',
      component: () => import('/@/views/certification/tax-audit-list/index.vue'),
      meta: {
        title: t('routes.certification.tax-audit-list'),
        roles: [20222631],
      },
    },
  ],
};

export default route;
